import { forwardRef } from "react";
import CardShell from "./CardShell";
import ContactFooter from "./ContactFooter";
import { lei, packTotals, shortName } from "@/lib/pricing";

const Tile = ({ product, qty, gift }) => (
  <div className={`pk-tile ${gift ? "pk-tile--gift" : ""}`}>
    <div className="pk-tile-img">{product.image && <img src={product.image} alt={product.name} />}</div>
    <span className="pk-qty">×{qty}</span>
    <div className="pk-tile-name">{shortName(product.name)}</div>
    <div className="pk-tile-size">{product.size}</div>
  </div>
);

const PackageCard = forwardRef(function PackageCard({ pack, index, cat, contact }, ref) {
  const byId = Object.fromEntries(cat.products.map((p) => [p.id, p]));
  const t = packTotals(pack, cat);
  const vat = cat.vat;
  return (
    <CardShell ref={ref} variant="pack" testId={`package-card-${pack.id}`}>
      <header className="mc-head">
        <div>
          <div className="mc-wordmark">MEDAVITA</div>
          <div className="mc-line">Instant Bond Repair</div>
        </div>
        <div className="mc-index">PACHET {String(index).padStart(2, "0")}</div>
      </header>

      <section className="pk-intro">
        <div className="pk-medal" data-testid={`package-card-discount-${pack.id}`}>
          <span>-{pack.discount}%</span>
          <small>discount</small>
        </div>
        <h2 className="pk-title" data-testid={`package-card-name-${pack.id}`}>{pack.name}</h2>
        <p className="pk-tagline">{pack.tagline}</p>
        <div className="mc-kicker">{t.pieces} produse{t.giftPieces ? ` + ${t.giftPieces} cadou` : ""}</div>
      </section>

      <section className="pk-grid">
        {pack.items.map((it) => byId[it.id] && <Tile key={it.id} product={byId[it.id]} qty={it.qty} />)}
      </section>

      {pack.gifts?.length > 0 && (
        <section className="pk-gifts" data-testid={`package-card-gifts-${pack.id}`}>
          <div className="pk-gifts-label">
            <b>Cadou</b>
            <span>valoare {lei(t.gifts)}</span>
          </div>
          <div className="pk-gifts-row">
            {pack.gifts.map((it) => byId[it.id] && <Tile key={it.id} product={byId[it.id]} qty={it.qty} gift />)}
          </div>
        </section>
      )}

      <section className="pk-price">
        <div>
          <div className="pk-was">Valoare listă <s>{lei(t.list)}</s></div>
          <div className="mc-price" data-testid={`package-card-price-${pack.id}`}>
            <span className="mc-price-amount pk-amount">{Math.round(t.price).toLocaleString("ro-RO")}</span>
            <span className="mc-price-unit">lei</span>
          </div>
          <div className="mc-vat" data-testid={`package-card-vat-${pack.id}`}>TVA {vat}% inclus</div>
        </div>
        <div className="pk-save">
          <small>Economisești</small>
          <b>{lei(t.savings)}</b>
        </div>
      </section>

      <div className="pk-profit" data-testid={`package-card-profit-${pack.id}`}>
        <span>{t.treatments} tratamente <b>{lei(t.treatRevenue)}</b> + revânzare <b className="is-resale">{lei(t.resale)}</b></span>
        <span>Profit <b>{lei(t.profit)}</b></span>
      </div>

      <ContactFooter contact={contact} cta={<>Răspunde cu <b>„{pack.name.replace("Pachet ", "")}”</b></>} />
    </CardShell>
  );
});

export default PackageCard;
